var basicValidation = require('src/interlock/no-ui/validation/common/basic');
var DEALER_LOCATOR = '1';
var pageValues = window.EDM.PageValues;

function fillUserInfo(formData) {
    return {
        'email': formData.email,
        'firstname': formData.firstname,
        'lastname': formData.lastname,
        'area': formData.phone.slice(0, 3),
        'phonePrefix': formData.phone.slice(3, 6),
        'phoneSuffix': formData.phone.slice(6)
    };
}

function fillData(formData, vehData, zipcode, leadOpportunityKey, timestamp){
    if(vehData.leadType === DEALER_LOCATOR){
        return fillDealerLocatorData(formData, vehData, zipcode, leadOpportunityKey, timestamp);
    }
    return fillNewCarLeadData(formData, vehData, zipcode, leadOpportunityKey, timestamp);
}

function fillDealerLocatorData(formData, selectedVehData, zip, leadOpportunityKey, timestamp) {
    return {
        'zipCode': zip,
        'userInfoDto': fillUserInfo(formData),
        'make': selectedVehData.make,
        'styleId': selectedVehData.styleId,
        'dealerId':selectedVehData.franchise,
//        'clientip': '10.32.221.21',
        'bannerCode': timestamp,
        'leadOpportunityKey': leadOpportunityKey,
        'referringurl': 'http://www.edmunds.com/inventory/lead_form_certificate.html',
        'tags': '#find'
    };
}

function fillNewCarLeadData(formData, selectedVehData, zip, leadOpportunityKey, timestamp) {
    return {
        'gpExpirationDate': selectedVehData.gpExpirationDate,
        'zipcode': zip,
        'userInfoDto': fillUserInfo(formData),
        'inventoryInfoDto': {
            'vin': selectedVehData.vin
        },
//        'clientip': '10.32.221.21',
        'bannerCode': timestamp,
        'leadOpportunityKey': leadOpportunityKey,
        'referringurl': 'http://www.edmunds.com/inventory/lead_form_certificate.html',
        'tags': '#find'
    };
}

function fillLeadOpportunityKey(vehData, index, totalPossibleLeads) {
    return {
        'leadNumber': index + 1,
        'totalSubmitted': index + 1,
        'position': vehData.position,
        'totalPossible': totalPossibleLeads
    };
}

var fillThankyouData = function(formData, selData){
    var submissions = [];
    selData.map(function (vehData) {
        var tempObj = {
            'vin':(vehData.vin ? vehData.vin : null),
            'dealer':(vehData.dealer ? vehData.dealer : null),
            'leadType': vehData.leadType
        };
        submissions.push(tempObj);
    });

    return {
        'firstName': formData.firstName.value,
        'lastName': formData.lastName.value,
        'submissions': submissions,
        'make': pageValues.vehicle.make.niceName || '',
        'model': pageValues.vehicle.model.niceName || '',
        'year': pageValues.vehicle.modelYear.year || ''
    };
};


function getFormData(form) {
    return {
        firstname: form.firstName.value,
        lastname: form.lastName.value,
        email: form.email.value,
        phone: basicValidation.getPhoneNumbers(form.phoneNumber.value)
    };
}

function reflect(promise) {
    return promise.then(function(v) {
        return { v:v, status: true };
    },  function (e) {
        return { e:e, status: false };
    });
}

function readyCollapse(){
    var pannelCollapse = $('.lead-form .panel-collapse');
    $('[data-toggle="popover"]').popover();

    pannelCollapse.on('show.bs.collapse hide.bs.collapse', function(e){
        $('.collapse-control', e.target.parentNode).addClass('hidden-xs-up');
    });
}

function switchToDrawer(fromSelector, toSelector) {
    $(fromSelector).modal('toggle');
    $(fromSelector).one('hidden.bs.modal', function() {
        $(toSelector).modal('toggle');
    });
}

function getThankYouPageUrl() {
    var tyUrl = '/groundwork/lead/thank-you/inventory/new/price-promise-multi-select/index.entry?entry-id=new-pp-multi-select-thank-you';

    return tyUrl;
}

module.exports = {
    fillThankyouData:fillThankyouData,
    fillNewCarLeadData: fillNewCarLeadData,
    fillLeadOpportunityKey: fillLeadOpportunityKey,
    fillDealerLocatorData:fillDealerLocatorData,
    getFormData:getFormData,
    fillData:fillData,
    reflect:reflect,
    readyCollapse:readyCollapse,
    switchToDrawer:switchToDrawer,
    getThankYouPageUrl:getThankYouPageUrl

};


//////////////////
// WEBPACK FOOTER
// ./src/creative/pricing-lead-form/utils.js
// module id = 12
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 16 19